import { Typography, Stack, Card } from '@mui/material';
import { t } from 'i18next'
import { THubstripeCustomer } from '../../../shared/types/hubstripeCustomer.type'


//COMPONENTS
import BillingInvoicesItemsTable from "./BillingInvoicesItemsTable";

type BillingInvoicesProps = {
    invoices: any;
    creditNotes: any;
    cegidDocs: any;
    paymentMethods: any;
    customer: THubstripeCustomer;
}

function BillingInvoices({ invoices, creditNotes, cegidDocs, paymentMethods, customer }: BillingInvoicesProps) {

    let filteredInvoices = []
    if (invoices != null) {
        filteredInvoices = invoices.filter((invoice: any) => { return invoice.status != "draft" && invoice.status != "void" })
    }

    return (
        <Card sx={{ p: 3 }}>
            {invoices != null && (
                <div className="fixed-width">
                    <Stack spacing={2}>
                        <Typography variant="h5" color="inherit" noWrap sx={{ flexGrow: 1 }}>
                            {t("billing:invoices")}
                        </Typography>
                        <BillingInvoicesItemsTable
                            invoices={filteredInvoices}
                            creditNotes={creditNotes}
                            cegidDocs={cegidDocs}
                            paymentMethods={paymentMethods}
                            customer={customer}
                        />
                    </Stack>
                </div>
            )
            }
        </Card>
    );
}

export default BillingInvoices;
